import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  version: string;
  currentYear = new Date().getFullYear();
  width: number;

  constructor(
    private authenticationService: AuthenticationService
  ) {
    this.version = environment.version;  }

  ngOnInit(): void {
    // can perform any logical implemention here if required
  }
}
